import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  private http = inject(HttpClient);

  getConnections(userId: number, q = ''): Observable<any[]> {
    const url = q.trim()
      ? `/api/connections/${userId}?q=${encodeURIComponent(q)}`
      : `/api/connections/${userId}`;
    return this.http.get<any[]>(url);
  }

  getIncomingRequests(userId: number): Observable<any[]> {
    return this.http.get<any[]>(`/api/connections/${userId}/requests`);
  }

  getSentRequests(userId: number): Observable<any[]> {
    return this.http.get<any[]>(`/api/connections/${userId}/sent`);
  }

  getRecommended(userId: number): Observable<any[]> {
    return this.http.get<any[]>(`/api/connections/${userId}/recommended`);
  }

  sendRequest(requester_id: number, addressee_id: number): Observable<any> {
    return this.http.post('/api/connections/request', { requester_id, addressee_id });
  }

  createConnection(requester_id: number, addressee_id: number): Observable<any> {
    return this.http.post('/api/connections/create', { requester_id, addressee_id });
  }

  respondToRequest(
    connectionId: number,
    status: 'accepted' | 'rejected',
    userId: number,
  ): Observable<any> {
    return this.http.patch(`/api/connections/${connectionId}/respond`, { status, userId });
  }

  removeConnection(connectionId: number, userId: number): Observable<any> {
    return this.http.request('delete', `/api/connections/${connectionId}`, { body: { userId } });
  }
}
